import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import {resetBlock, reportAnalytics, reportTagManager, reportFbqAnalytics} from '../saleBlockSlice';
import {clearStateHistoryAction} from '../../../../utilities/stateHistory/stateHistorySlice';
import OrderSuccess from '../OrderSuccess/OrderSuccess';

const SuccessPage = (props) => {
  let saleType = props.saleType;
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'visibility_14' : 'visibility_25',
          eventLabel: eventLabel,
        });
        props.reportFbqAnalytics({event: 'Purchase', data: {Product_type: 'TV', value: props.totalPrice, currency: 'ILS'}});
        break;
      case 'app':
        props.reportAnalytics({eventCategory: 'app_newsale_process', eventAction: 'visibility_33', eventLabel: eventLabel});
        break;
      case 'cellular':
        props.reportAnalytics({
          eventCategory: 'cellular_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'visibility_15' : 'visibility_28',
          eventLabel: flowType == 'existsCustomer' ? 'screen_10' : 'screen_18',
        });
        props.reportFbqAnalytics({event: 'Purchase', data: {Product_type: 'Cellular', value: props.totalPrice, currency: 'ILS'}});
        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_28', eventLabel: 'screen_3'});
        props.reportFbqAnalytics({event: 'Purchase', data: {Product_type: 'Fiber', value: props.totalPrice, currency: 'ILS'}});
        break;
    }
    props.reportTagManager('saleTransaction');

    return () => {
      props.resetBlock();
      props.clearStateHistoryAction();
    };
  }, []);

  //page params
  let isDisplayFooter = false;
  let btnText = 'המשך';
  let currentPageFunction = null;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let saleInfo = {
    personalInfo: props.personalInfo,
    otpPhone: props.otpPhone,
    suggestionCallBackCode: props.configuration.suggestionCallBackCode,
    isShowSuggestionAtEnd: props.configuration.isShowSuggestionAtEnd,
    suggestionButtonText: props.configuration.suggestionButtonText,
    suggestionTitle: props.configuration.suggestionTitle,
    SuggestionSuccessText: props.configuration.SuggestionSuccessText,
    isShowAppDownloadLinks: props.configuration.isShowAppDownloadLinks,
    urlGoogle: props.saleBlockData.urlGoogle,
    urlApple: props.saleBlockData.urlApple,
    instructionLink: props.saleBlockData.instructionLink,
    orderSuccessTitle: props.saleBlockData.orderSuccessTitle,
    orderSuccessDescription: {
      delivery: props.saleBlockData.orderSuccessDescriptionDelivery,
      technician: props.saleBlockData.orderSuccessDescriptionTechnician,
    },
    supplyType: props.supplyType,
    setupDeliveries: props.setupDeliveries,
    technicianArrivalTime: props.technicianArrivalTime,
    selectedAddress: props.selectedAddress,
    saleType: props.saleType,
    flowType: props.flowType,
    productsInfo: props.productsInfo,
  };

  let currentPageView = <OrderSuccess saleInfo={saleInfo} esim={props.esim} context={props.context} />;

  return (
    <div className='slideAnimation'>
      <div className='sale-page-content' id='order-number' data-transaction-id={props.transactionId} data-ban={props.personalInfo.ban}>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    personalInfo: state.saleBlock.personalInfo,
    otpPhone: state.saleBlock.otpPhone,
    saleBlockData: state.saleBlock.epiServer.saleBlock,
    configuration: state.saleBlock.epiServer.configuration,
    supplyType: state.saleBlock.supplyType,
    setupDeliveries: state.saleBlock.setupDeliveries,
    technicianArrivalTime: state.saleBlock.technicianArrivalTime,
    selectedAddress: state.saleBlock.selectedAddress,
    productsInfo: state.saleBlock.productsInfo,
    totalPrice: state.saleBlock.totalPrice,
    transactionId: state.saleBlock.transactionId,
    esim: state.saleBlock.esim,
  };
};

const mapDispatchToProps = {resetBlock, reportAnalytics, reportTagManager, reportFbqAnalytics, clearStateHistoryAction};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
